<div class="slider">
    @for(category of categories; track category.code){
    <div class="card">
        <img [src]="getCardImage(category.code)" [alt]="category.tituloKey | translate">
        <div class="card-title">
            <h1>{{category.group}}:</h1>
            <h1>{{category.tituloKey | translate}} {{'HOME.AND_MORE' | translate}} {{category.sloganKey | translate | lowercase}}</h1>
            <button [routerLink]="category.route" [queryParams]="category.queryParams" class="primaryButton"
                (click)="$event.stopPropagation()">{{'HOME.EXPLORE' | translate}}</button>
        </div>
    </div>
    }
</div>